import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Slider from '../../../common/Slider/Slider';
import { transformHTML } from '../../../helpers/transformHTML';
import Button from '../../../common/button/Button';

const MusicSingleLyrics = (props) => {
    const structureLyrics = [];

    if (props.isMobile) {
        // push  original lyrics
        structureLyrics.push(
            <div className="original" key={0}>
                <h3 className="typeOfLyricOriginals">Original</h3>
                {
                    props.musicLyrics ?
                        transformHTML(props.musicLyrics)
                        :
                        <p className="noContentWarning">
                            Não há letra disponível para essa faixa... : (
                            <br />
                            Entre em
                            <Button title="Entre em contato" to="/contato" className="TextLink">contato</Button>
                            {' '}
                            para ajudar a completar a página!
                        </p>
                }
            </div>,
        );

        // push traducao lyrics
        structureLyrics.push(
            <div className="translated" key={1}>
                <h3 className="typeOfLyricTraduction">Tradução</h3>
                {
                    props.musicTranslation ?
                        transformHTML(props.musicTranslation)
                        :
                        <p className="noContentWarning">
                            Não há tradução disponível para essa faixa... : (
                            <br />
                            Entre em
                            <Button title="Entre em contato" to="/contato" className="TextLink">contato</Button>
                            {' '}
                            para ajudar a completar a página!
                        </p>
                }
            </div>,
        );

        return (
            <div className="musicSinglePageLyrics">
                <Slider
                    autoplay={false}
                    loop={false}
                    navigation
                >
                    {structureLyrics}
                </Slider>
            </div>
        );
    }

    return (
        <div className="musicSinglePageLyrics">
            <div className="original" key={0}>
                <h3 className="typeOfLyricOriginals">Original</h3>
                {
                    props.musicLyrics ?
                        transformHTML(props.musicLyrics)
                        :
                        <p className="noContentWarning">
                            Não há letra disponível para essa faixa... : (
                            <br />
                            Entre em
                            <Button title="Entre em contato" to="/contato" className="TextLink">contato</Button>
                            {' '}
                            para ajudar a completar a página!
                        </p>
                }
            </div>
            <div className="translated" key={1}>
                <h3 className="typeOfLyricTraduction">Tradução</h3>
                {
                    props.musicTranslation ?
                        transformHTML(props.musicTranslation)
                        :
                        <p className="noContentWarning">
                            Não há tradução disponível para essa faixa... : (
                            <br />
                            Entre em
                            <Button title="Entre em contato" to="/contato" className="TextLink">contato</Button>
                            {' '}
                            para ajudar a completar a página!
                        </p>
                }
            </div>
        </div>
    );
};

MusicSingleLyrics.propTypes = exact({
    musicLyrics: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.object.isRequired,
    ]),
    musicTranslation: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.object.isRequired,
    ]),
    isMobile: PropTypes.bool.isRequired,
});

export default MusicSingleLyrics;
